import { DashboardT } from 'business/definitions';
import React from 'react';
import { PdfPreviewText } from 'routes/Dashboard/components/PdfPreviewText';
import PdfPreviewModal from './PdfPreviewModal';
import { useTranslation } from 'react-i18next';

interface DashboardPdfPreviewModalProps {
    openPDFPreview: boolean;
    setOpenPDFPreview: (open: boolean) => void;
    dashboard: DashboardT;
}

const DashboardPdfPreviewModal = ({
    openPDFPreview,
    setOpenPDFPreview,
    dashboard,
}: DashboardPdfPreviewModalProps) => {
    const { t } = useTranslation();
    return (
        <PdfPreviewModal
            open={openPDFPreview}
            url={`explore/dashboard/${dashboard.key}/pdf`}
            onClose={() => setOpenPDFPreview(false)}
            title={t('exportDashboard.waitForPreview')}
            hasDownloadButton
            downloadTitle={dashboard.title}
            downloadTrackingEvent={{
                name: 'decision/dashboard/options/pdf-export-modal/pdf-download-click',
                payload: { dashboard: dashboard.key },
            }}
            onSuccessText={<PdfPreviewText />}
            shouldDisplayFixedWidthText={dashboard.isFullWidth}
        />
    );
};

export default DashboardPdfPreviewModal;
